import { watch } from '#imports';
import type { ShallowRef } from 'vue';
import { useElementVisibility } from '@vueuse/core';

export function watchElementVisible(
  elementRef: Readonly<ShallowRef<HTMLElement | null>>,
  handle: () => void,
) {
  const visible = useElementVisibility(elementRef, { once: true });
  watch(visible, handle, { once: true });
}
